export const SUPPORTED_LOCALES = ['es-AR', 'en-US', 'pt-BR'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'es-AR';

const GUEST_LOCALE_KEY = 'guestPreferredLocale';

export function normalizeLocaleTag(tag: string | null | undefined): SupportedLocale | null {
    if (!tag?.trim()) {
        return null;
    }

    const trimmed = tag.trim();
    for (const supported of SUPPORTED_LOCALES) {
        if (supported.toLowerCase() === trimmed.toLowerCase()) {
            return supported;
        }
    }

    const normalized = trimmed.replace('_', '-');
    const [language, region] = normalized.split('-');
    if (language && region) {
        const candidate = `${language.toLowerCase()}-${region.toUpperCase()}`;
        if (SUPPORTED_LOCALES.includes(candidate as SupportedLocale)) {
            return candidate as SupportedLocale;
        }
    }

    switch (language?.toLowerCase()) {
        case 'en':
            return 'en-US';
        case 'pt':
            return 'pt-BR';
        case 'es':
            return 'es-AR';
        default:
            return null;
    }
}

export function resolveDeviceLocale(): SupportedLocale {
    if (typeof navigator === 'undefined') {
        return DEFAULT_LOCALE;
    }

    const candidates = [...(navigator.languages ?? []), navigator.language].filter(Boolean);
    for (const candidate of candidates) {
        const resolved = normalizeLocaleTag(candidate);
        if (resolved) {
            return resolved;
        }
    }

    return DEFAULT_LOCALE;
}

export function readGuestPreferredLocale(): string | null {
    try {
        return localStorage.getItem(GUEST_LOCALE_KEY)?.trim() || null;
    } catch {
        return null;
    }
}

export function resolvePreferredLocale(
    preferredLocale?: string | null,
    guestPreferredLocale?: string | null,
): SupportedLocale {
    // Language selector temporarily hidden for production: always Spanish.
    // Restore the resolution below when re-enabling the language selector UI.
    void preferredLocale;
    void guestPreferredLocale;
    return DEFAULT_LOCALE;

    // const fromUser = normalizeLocaleTag(preferredLocale);
    // if (fromUser) {
    //     return fromUser;
    // }
    //
    // const fromGuest = normalizeLocaleTag(guestPreferredLocale ?? readGuestPreferredLocale());
    // if (fromGuest) {
    //     return fromGuest;
    // }
    //
    // return resolveDeviceLocale();
}
